module.exports = __webpack_public_path__ + "img/icon-heart.654981aa.svg";